var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { ColumnAlignmentStyles } from '../Table.interface';
export const TableBodyCell = (_a) => {
    var { alignment, width = 0, depth = 0, children, onClick } = _a, restProps = __rest(_a, ["alignment", "width", "depth", "children", "onClick"]);
    const cellClassName = ['table-body-cell', ColumnAlignmentStyles[alignment]].filter(Boolean).join(' ');
    return (_jsx("td", Object.assign({ className: cellClassName, style: { flex: width }, tabIndex: -1, onClick: onClick }, restProps, { children: _jsx("div", { className: "table-body-cell-content", style: { '--row-depth': depth }, children: children }) })));
};
